// extracted by mini-css-extract-plugin
export default {"container":"SubscriptionBonusDialog_container__FIWzG","label":"SubscriptionBonusDialog_label__TgXUu","value":"SubscriptionBonusDialog_value__OPWkS"};